
import React from 'react';
import {VimeoPopup} from "../funcs/vimeo";
import {Action} from "../funcs/utils";

const WELCOME_VIDEO = "844028260";

const NewAccountPrimer = props => {

  const component = props.component;

  const on_go = () => {
    component.hidePrimer();
  }

  const footer_style = {
    display: "flex",
    width: "100%",
    justifyContent: "center",
    marginTop: "1rem",
    marginBottom: "1rem",
  }

  const button_width = "10rem";
  const action_style = {
    width: "100%",
    padding: "0.5rem 0.5rem",
  }

  const footer = (
    <div style={footer_style}>
      <div style={{ width: button_width }}>
        <Action
          style={action_style}
          onClick={on_go}>
          Go
        </Action>
      </div>
    </div>
  )

  const video_style = {
    width: "640px",
    height: "360px",
  }
  return (
    <VimeoPopup
      no_header={true}
      footer={footer}
      style={video_style}
      autoplay={true}
      video_id={WELCOME_VIDEO}/>);
}

export { NewAccountPrimer };
